import axios from "../plugins/axios.plugin";

class BusinessVerificationLevelService {
  baseServicePath = "/api/business-verification-level";

  getAllBusinessVerification() {
    return axios.get(`${this.baseServicePath}/me?properties=1`);
  }

  showABusinessVerification(user_id) {
    return axios.get(
      `${this.baseServicePath}/show?user_id=${user_id}&properties=1`
    );
  }

  editBusinessVerification(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }

  filterBusinessVerificationLevel(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}`,
      payload
    );
  }

  storeBusinessVerificationLevel(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }

  searchBusinessVerificationLevel(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }

  verifyBusinessVerification(payload) {
    return axios.post(`${this.baseServicePath}/verify`, payload);
  }

  rejectBusinessVerification(payload) {
    return axios.post(`${this.baseServicePath}/reject`, payload);
  }
}

export const businessVerificationLevelService = new BusinessVerificationLevelService();
